import React from "react";
import Modal from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import styled from "styled-components";

const ConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  title: string;
  cancelText?: string;
  confirmText: string;
  onConfirm?: any;
  icon?: string | undefined;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "confirmModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />
          {oProps.icon && (
            <img className="icon" src={oProps.icon} alt="아이콘" />
          )}
          <p
            className={`titleFont ${!oProps.cancelText && "gap"} 
            ${oProps.icon && "icon"}
            `}
          >
            {oProps.title}
          </p>

          <div className="bottomButtonWrap">
            {oProps.cancelText && (
              <div className="cancelButton" onClick={onCloseModal}>
                {oProps.cancelText}
              </div>
            )}
            <div
              className="confirmButton"
              onClick={oProps.onConfirm ? oProps.onConfirm : onCloseModal}
            >
              {oProps.confirmText}
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ConfirmModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding: 77px 0;
    font-size: 24px;
    line-height: 34px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
  .titleFont.icon {
    padding: 20px 0 40px 0;
  }

  img.icon {
    margin-top: 14px;
    width: 63px;
    height: 63px;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #555555;
      background: #e5e5e5;
      border: 1px solid #e5e5e5;
    }

    .confirmButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
